import { List, ListItem, Toggle } from "konsta/react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { appSlice } from "../../app/appSlice";
import LightBrightIcon from "../icons/light-bright-icon";
import { getColorForCode, colorShows } from "../../app/colors";

function Lights() {
  const dispatch = useAppDispatch();
  const poolLightsColor = useAppSelector((state) =>
    getColorForCode(state.app.poolLightsColor)
  );
  const poolLightsColorShow = useAppSelector((state) =>
    state.app.poolLightsColorShow
      ? colorShows.find((show) => show.id === state.app.poolLightsColorShow)
      : null
  );
  const spaLightsColor = useAppSelector((state) =>
    getColorForCode(state.app.spaLightsColor)
  );
  const spaLightsColorShow = useAppSelector((state) =>
    state.app.spaLightsColorShow
      ? colorShows.find((show) => show.id === state.app.spaLightsColorShow)
      : null
  );
  const bubblerLightsColor = useAppSelector((state) =>
    getColorForCode(state.app.bubblerLightsColor)
  );
  const bubblerLightsColorShow = useAppSelector((state) =>
    state.app.bubblerLightsColorShow
      ? colorShows.find((show) => show.id === state.app.bubblerLightsColorShow)
      : null
  );
  const waterfallLightsColor = useAppSelector((state) =>
    getColorForCode(state.app.waterfallLightsColor)
  );
  const waterfallLightsColorShow = useAppSelector((state) =>
    state.app.waterfallLightsColorShow
      ? colorShows.find(
          (show) => show.id === state.app.waterfallLightsColorShow
        )
      : null
  );
  return (
    <div>
      <List strong>
        <ListItem
          link
          onClick={(e) => {
            dispatch(appSlice.actions.setEditingLightColor("poolLights"));
          }}
          title={
            <div>
              <div className="font-bold">Pool Lights</div>
              <div className="flex flex-row items-center text-sm">
                {poolLightsColorShow ? (
                  <div className="w-4 mr-2 rounded-full border-gray-500 border">
                    {poolLightsColorShow.icon}
                  </div>
                ) : (
                  <div
                    className="w-4 h-4 mr-2 rounded-full bg-red border-gray-500 border"
                    style={{ backgroundColor: poolLightsColor.color }}
                  ></div>
                )}
                <div>
                  {poolLightsColorShow
                    ? poolLightsColorShow.name
                    : poolLightsColor.name}
                </div>
              </div>
            </div>
          }
          chevron={true}
          after={
            <div className="flex flex-row items-center justify-center text-blue-500">
              <div
                className="mr-3 flex flex-row items-center"
                onClick={(e) => {
                  dispatch(
                    appSlice.actions.setEditingLightBrightness("poolLights")
                  );
                  e.stopPropagation();
                }}
              >
                <LightBrightIcon className="w-5 mr-1"></LightBrightIcon>
                <div>
                  {useAppSelector((state) => state.app.poolLightsBrightness)}%
                </div>
              </div>
              <Toggle
                component="label"
                className="-my-1"
                checked={useAppSelector((state) => state.app.poolLights)}
                colors={{ checkedBgIos: "bg-green-toggle" }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  dispatch(appSlice.actions.togglePoolLights());
                  e.stopPropagation();
                }}
              />
            </div>
          }
        />
        <ListItem
          link
          onClick={(e) => {
            dispatch(appSlice.actions.setEditingLightColor("spaLights"));
          }}
          title={
            <div>
              <div className="font-bold">Spa Lights</div>
              <div className="flex flex-row items-center text-sm">
                {spaLightsColorShow ? (
                  <div className="w-4 mr-2 rounded-full border-gray-500 border">
                    {spaLightsColorShow.icon}
                  </div>
                ) : (
                  <div
                    className="w-4 h-4 mr-2 rounded-full bg-red border-gray-500 border"
                    style={{ backgroundColor: spaLightsColor.color }}
                  ></div>
                )}
                <div>
                  {spaLightsColorShow
                    ? spaLightsColorShow.name
                    : spaLightsColor.name}
                </div>
              </div>
            </div>
          }
          chevron={true}
          after={
            <div className="flex flex-row items-center justify-center text-blue-500">
              <div
                className="mr-3 flex flex-row items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    appSlice.actions.setEditingLightBrightness("spaLights")
                  );
                }}
              >
                <LightBrightIcon className="w-5 mr-1"></LightBrightIcon>
                <div>
                  {useAppSelector((state) => state.app.spaLightsBrightness)}%
                </div>
              </div>
              <Toggle
                component="label"
                className="-my-1"
                checked={useAppSelector((state) => state.app.spaLights)}
                colors={{ checkedBgIos: "bg-green-toggle" }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  dispatch(appSlice.actions.toggleSpaLights());
                }}
              />
            </div>
          }
        />
        <ListItem
          link
          onClick={(e) => {
            dispatch(appSlice.actions.setEditingLightColor("bubblerLights"));
          }}
          title={
            <div>
              <div className="font-bold">Bubbler Lights</div>
              <div className="flex flex-row items-center text-sm">
                {bubblerLightsColorShow ? (
                  <div className="w-4 mr-2 rounded-full border-gray-500 border">
                    {bubblerLightsColorShow.icon}
                  </div>
                ) : (
                  <div
                    className="w-4 h-4 mr-2 rounded-full bg-red border-gray-500 border"
                    style={{ backgroundColor: bubblerLightsColor.color }}
                  ></div>
                )}
                <div>
                  {bubblerLightsColorShow
                    ? bubblerLightsColorShow.name
                    : bubblerLightsColor.name}
                </div>
              </div>
            </div>
          }
          chevron={true}
          after={
            <div className="flex flex-row items-center justify-center text-blue-500">
              <div
                className="mr-3 flex flex-row items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    appSlice.actions.setEditingLightBrightness("bubblerLights")
                  );
                }}
              >
                <LightBrightIcon className="w-5 mr-1"></LightBrightIcon>
                <div>
                  {useAppSelector((state) => state.app.bubblerLightsBrightness)}
                  %
                </div>
              </div>
              <Toggle
                component="label"
                className="-my-1"
                checked={useAppSelector((state) => state.app.bubblerLights)}
                colors={{ checkedBgIos: "bg-green-toggle" }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  dispatch(appSlice.actions.toggleBubblerLights());
                }}
              />
            </div>
          }
        />
        <ListItem
          link
          onClick={(e) => {
            dispatch(appSlice.actions.setEditingLightColor("waterfallLights"));
          }}
          title={
            <div>
              <div className="font-bold">Waterfall Lights</div>
              <div className="flex flex-row items-center text-sm">
                {waterfallLightsColorShow ? (
                  <div className="w-4 mr-2 rounded-full border-gray-500 border">
                    {waterfallLightsColorShow.icon}
                  </div>
                ) : (
                  <div
                    className="w-4 h-4 mr-2 rounded-full bg-red border-gray-500 border"
                    style={{ backgroundColor: waterfallLightsColor.color }}
                  ></div>
                )}
                <div>
                  {waterfallLightsColorShow
                    ? waterfallLightsColorShow.name
                    : waterfallLightsColor.name}
                </div>
              </div>
            </div>
          }
          chevron={true}
          after={
            <div className="flex flex-row items-center justify-center text-blue-500">
              <div
                className="mr-3 flex flex-row items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(
                    appSlice.actions.setEditingLightBrightness(
                      "waterfallLights"
                    )
                  );
                }}
              >
                <LightBrightIcon className="w-5 mr-1"></LightBrightIcon>
                <div>
                  {useAppSelector(
                    (state) => state.app.waterfallLightsBrightness
                  )}
                  %
                </div>
              </div>
              <Toggle
                component="label"
                className="-my-1"
                checked={useAppSelector((state) => state.app.waterfallLights)}
                colors={{ checkedBgIos: "bg-green-toggle" }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  dispatch(appSlice.actions.toggleWaterfallLights());
                }}
              />
            </div>
          }
        />
      </List>
    </div>
  );
}

export default Lights;
